import React, { Component } from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import ScrollToTop from './ScrollToTop'

import Header from './common/Header'
import Home from './Home'
import NotFound from './NotFound'
import Footer from './common/Footer'


class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <ScrollToTop>
        <div>
          <Header />
          <Switch>
            <Route exact path="/" component={Home} />
            <Route path="*" component={NotFound}/>
          </Switch>
          <Footer />
        </div>
        </ScrollToTop>
      </BrowserRouter>
    );
  }
}

export default App



// WEBPACK FOOTER //
// ./src/components/App.js